module.exports = __webpack_public_path__ + "img/LayerAufteilung.5f0b466e.png";